// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2XZFE","title":"ClientInsurance_title__24O_C","itemText":"ClientInsurance_itemText__509qP"};